import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import usIcon from "../assets/header/us_flag.png";
import jpIcon from "../assets/header/ja_flag.png";
import { CLIENT_PORTAL, BLOG_URL } from "../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactGA from "react-ga4";
import { faBars, faGlobe } from "@fortawesome/free-solid-svg-icons";
export const Navigation = (props) => {
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isTablet, setIsTablet] = useState(
    768 <= window.innerWidth && window.innerWidth <= 1310
  );
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const { t, i18n } = useTranslation();
  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  const handleNavToggle = () => {
    setIsNavCollapsed(!isNavCollapsed);
  };

  const handleNavLinkClick = () => {
    if (isMobile) {
      setIsNavCollapsed(true);
    }
  };
  const handleScrollFormOtherPage = (component) => {
    const compo = document.getElementById(component);
    if (!compo) {
      ReactGA.send({
        hitType: "pageview",
        page: component,
        title: "Redirect to page",
      });
      setTimeout(() => {
        const compo = document.getElementById(component);
        if (compo) {
          compo.scrollIntoView({ behavior: "smooth" });
        }
      }, 1500);
    }
  };
  useEffect(() => {
    const navbar = document.querySelector(".navbar-fixed-top");

    const handleScroll = () => {
      let st = window.scrollY || document.documentElement.scrollTop;
      if (isMobile) {
        // const navbarCollapse = document.querySelector(".navbar-collapse");
        // if (lastScrollTop >= st) {
        //   navbar.classList.remove("navbar-hidden");
        // } else {
        //   navbar.classList.add("navbar-hidden");
        //   navbarCollapse.classList.remove("in");
        // }
        navbar.classList.add("navbar-fixed");
      } else {
        if (st > 100) {
          navbar.classList.add("navbar-fixed");
        } else {
          navbar.classList.remove("navbar-fixed");
        }
      }
      setLastScrollTop(st <= 0 ? 0 : st);
    };
    function handleResize() {
      const newIsMobile = window.innerWidth < 768;
      const newIsTablet = 768 < window.innerWidth && window.innerWidth <= 1310;
      setIsMobile(newIsMobile);
      setIsTablet(newIsTablet);

      // Reset navigation collapse state when switching to desktop
      if (!newIsMobile && !isNavCollapsed) {
        setIsNavCollapsed(true);
      }
    }

    // Add event listener
    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);
    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [lastScrollTop, isMobile, isTablet, isNavCollapsed]);
  return (
    <nav
      id="menu"
      className={
        "navbar navbar-default navbar-fixed-top " +
        (isMobile ? "navbar-fixed" : "")
      }
    >
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            onClick={handleNavToggle}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="./#page-top">
            <img
              className="logo"
              src={i18n.language === "ja" ? "img/logo-ja.png" : "img/logo.png"}
              alt="logo"
            />
          </a>
        </div>

        <div
          className={`collapse navbar-collapse ${
            !isNavCollapsed ? "in show" : ""
          }`}
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a
                href="./#header"
                className="page-scroll"
                onClick={() => {
                  handleScrollFormOtherPage("header");
                  handleNavLinkClick();
                }}
              >
                {t("home")}
              </a>
            </li>

            <li>
              <a
                href="./#services"
                className="page-scroll"
                onClick={() => {
                  handleScrollFormOtherPage("services");
                  handleNavLinkClick();
                }}
              >
                {t("services")}
              </a>
            </li>
            <li>
              <a
                href="./#pricing"
                className="page-scroll"
                onClick={() => {
                  handleScrollFormOtherPage("pricing");
                  handleNavLinkClick();
                }}
              >
                {t("pricing")}
              </a>
            </li>
            <li>
              <a
                href="./#about"
                className="page-scroll"
                onClick={() => {
                  handleScrollFormOtherPage("about");
                  handleNavLinkClick();
                }}
              >
                {t("about_us")}
              </a>
            </li>
            <li>
              <a
                href="./#contact"
                className="page-scroll"
                onClick={handleNavLinkClick}
              >
                {t("contact")}
              </a>
            </li>
            {!isTablet && (
              <li>
                <a
                  href={BLOG_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    ReactGA.event({
                      category: "Navigation",
                      action: "Click",
                      label: "Blogs Menu",
                    });
                    handleNavLinkClick();
                  }}
                >
                  {t("blogs")}
                </a>
              </li>
            )}
            {!isTablet && (
              <li>
                <button
                  className="btn btn-primary btn-login"
                  onClick={() => {
                    window.location.href = CLIENT_PORTAL + "/auth/login";
                    ReactGA.event({
                      category: "Landing Page",
                      action: "Click",
                      label: "Get Login Button",
                    });
                    handleNavLinkClick();
                  }}
                  type="button"
                >
                  {t("login")}
                </button>
              </li>
            )}
            {!isTablet && (
              <li>
                <button
                  className="btn btn-primary btn-sign-up"
                  onClick={() => {
                    window.location.href = CLIENT_PORTAL + "/auth/registration";
                    ReactGA.event({
                      category: "Landing Page",
                      action: "Click",
                      label: "Get Register Button",
                    });
                    handleNavLinkClick();
                  }}
                  type="button"
                >
                  {t("sign_up")}
                </button>
              </li>
            )}
            {!isTablet &&
              (isMobile ? (
                <li>
                  <div className="dropdown">
                    <button
                      className="btn btn-secondary dropdown-toggle"
                      id="dropdownMenuButton"
                      type="button"
                      onClick={() => {
                        changeLanguage(i18n.language === "en" ? "ja" : "en");
                        handleNavLinkClick();
                      }}
                    >
                      <img
                        src={i18n.language === "en" ? jpIcon : usIcon}
                        alt="language"
                      />
                      <p>{i18n.language === "en" ? "日本語" : "English"}</p>
                    </button>
                  </div>
                </li>
              ) : (
                <li>
                  <div className="dropdown">
                    <button
                      className="btn btn-secondary dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <FontAwesomeIcon
                        size={"2x"}
                        color="#3778f7"
                        icon={faGlobe}
                      />
                    </button>
                    <div
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <div
                        className="dropdown-item"
                        onClick={() => {
                          changeLanguage("en");
                          handleNavLinkClick();
                        }}
                      >
                        <img src={usIcon} alt="language" /> English
                      </div>
                      <div
                        className="dropdown-item"
                        onClick={() => {
                          changeLanguage("ja");
                          handleNavLinkClick();
                        }}
                      >
                        <img src={jpIcon} alt="language" /> 日本語
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            {isTablet && (
              <li>
                <div className="dropdown">
                  <button
                    className="btn btn-secondary dropdown-toggle"
                    type="button"
                    id="dropdownMenuButtonTablet"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <FontAwesomeIcon
                      size={"2x"}
                      color="#3778f7"
                      icon={faBars}
                    />
                  </button>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButtonTablet"
                  >
                    <div className="dropdown-item">
                      <a
                        href={BLOG_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                          ReactGA.event({
                            category: "Navigation",
                            action: "Click",
                            label: "Blogs Menu",
                          });
                          handleNavLinkClick();
                        }}
                        style={{ color: "#000", textDecoration: "none" }}
                      >
                        {t("blogs")}
                      </a>
                    </div>
                    <div className="dropdown-item">
                      <button
                        className="btn btn-secondary dropdown-toggle"
                        id="dropdownMenuButton"
                        type="button"
                        onClick={() => {
                          changeLanguage(i18n.language === "en" ? "ja" : "en");
                          handleNavLinkClick();
                        }}
                      >
                        <img
                          src={i18n.language === "en" ? jpIcon : usIcon}
                          alt="language"
                        />
                        <p>{i18n.language === "en" ? "日本語" : "English"}</p>
                      </button>
                    </div>
                    <div
                      className="dropdown-item"
                      onClick={() => {
                        changeLanguage("ja");
                        handleNavLinkClick();
                      }}
                    >
                      <button
                        className="btn btn-primary btn-login"
                        onClick={() => {
                          window.location.href = CLIENT_PORTAL + "/auth/login";
                          ReactGA.event({
                            category: "Landing Page",
                            action: "Click",
                            label: "Get Started Button",
                          });
                          handleNavLinkClick();
                        }}
                        type="button"
                      >
                        {t("login")}
                      </button>
                    </div>
                    <div className="dropdown-item">
                      <button
                        className="btn btn-primary btn-sign-up"
                        onClick={() => {
                          window.location.href =
                            CLIENT_PORTAL + "/auth/registration";
                          ReactGA.event({
                            category: "Landing Page",
                            action: "Click",
                            label: "Get Register Button",
                          });
                          handleNavLinkClick();
                        }}
                        type="button"
                      >
                        {t("sign_up")}
                      </button>
                    </div>
                  </div>
                </div>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};
